import BigNumber from 'bignumber.js';

/**
 * 公户金额展示：避免 1e-8 / 0E-16（接口未序列化为 plain string 时的兜底）
 */
export function formatPlainAmount(value) {
  if (value === null || value === undefined || value === '') return '0';
  try {
    const bn = new BigNumber(value);
    if (!bn.isFinite()) return '0';
    if (bn.isZero()) return '0';
    return bn.toFixed();
  } catch (e) {
    return String(value);
  }
}

/** 多项金额相加，避免 JS 浮点误差（如 0.021 + 0.0000243） */
export function sumPlainAmounts(items, pickAmount = (item) => item) {
  let total = new BigNumber(0);
  (items || []).forEach((item) => {
    const raw = pickAmount(item);
    if (raw === null || raw === undefined || raw === '') return;
    try {
      total = total.plus(new BigNumber(raw));
    } catch (e) {
      // ignore invalid fragment
    }
  });
  if (!total.isFinite() || total.isZero()) return '0';
  return total.toFixed();
}

export function formatSignedAmount(value) {
  if (value === null || value === undefined || value === '') return '0';
  try {
    const bn = new BigNumber(value);
    if (!bn.isFinite() || bn.isZero()) return '0';
    const text = formatPlainAmount(bn.abs());
    return bn.isPositive() ? `+${text}` : `-${text}`;
  } catch (e) {
    return String(value);
  }
}
